import { createFileRoute } from '@tanstack/react-router'
import privacyMarkdown from '@/content/privacy.md?raw'
import { LegalMarkdown } from '@/components/LegalMarkdown'

export const Route = createFileRoute('/privacy-policy')({
  head: () => ({
    meta: [
      { title: 'Privacy Policy — Halo Compliance' },
      { name: 'robots', content: 'noindex' },
      { property: 'og:title', content: 'Privacy Policy — Halo Compliance' },
      { property: 'og:url', content: 'https://www.halocompliance.com/privacy-policy' },
    ],
    links: [{ rel: 'canonical', href: 'https://www.halocompliance.com/privacy-policy' }],
  }),
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <div className="marketing-inner py-5">
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <LegalMarkdown markdown={privacyMarkdown} />
          </div>
        </div>
      </div>
    </div>
  )
}
